import React, { useState } from 'react';
import download from 'js-file-download';

import { tableCsvRows, toCsv } from 'app/src/utils/csv';

const ERROR_STYLE = { color: 'red', paddingLeft: 8 };

// Excel reads a CSV in the system codepage unless it opens with a byte order
// mark, which turns any non-ASCII name into mojibake.
const BYTE_ORDER_MARK = '\uFEFF';
const CSV_MIME_TYPE = 'text/csv;charset=utf-8';

// `fetchEntries` resolves with every entry the table's filters match, not just
// the page on screen.
const DownloadCsvButton = ({ columns, fetchEntries, filePrefix }) => {
  const [preparing, setPreparing] = useState(false);
  const [error, setError] = useState();

  const onClick = async () => {
    setPreparing(true);
    setError(null);

    try {
      const entries = await fetchEntries();

      download(
        BYTE_ORDER_MARK + toCsv(tableCsvRows(columns, entries)),
        `${filePrefix}-${new Date().getTime()}.csv`,
        CSV_MIME_TYPE
      );
    } catch (downloadError) {
      setError(downloadError?.message || 'The CSV could not be built.');
    } finally {
      setPreparing(false);
    }
  };

  return (
    <div data-testid="download-csv">
      <button type="button" onClick={onClick} disabled={preparing}>
        {preparing ? 'Preparing CSV...' : 'Download CSV'}
      </button>
      {error && <span style={ERROR_STYLE}>{error}</span>}
    </div>
  );
};

export default DownloadCsvButton;
